const closePositionPixels = 20;

export class GridLinesCtrl {
  constructor(DomService, $scope) {
    'ngInject';
    this.ds = DomService;
    this.$scope = $scope;

    this.styles = null;
    this.initialized = false;
    this.tokenDimensions = {};

    this.hideAll();
  }

  $onInit() {

    const wHide = this.$scope.$watch('$ctrl.hide', (newVal) => {
      if (newVal === false && !this.initialized) {
        this.initializeHelpers();
        this.setStyles();
      }
      this.hideAll();
    });

    const wLayout = this.$scope.$watch('$ctrl.token.layout', () => {
      if (this.initialized) this.setStyles();
    });

    const wDims = this.$scope.$watch('$ctrl.selectorDimensions', () => {
      this.updateDisplayFlags();
    });

    this.$scope.$on('$destroy', () => {
      wHide();
      wLayout();
      wDims();
    });
  }

  initializeHelpers() {
    this.$token = this.ds.getJqToken(this.token);
    this.$tokenGroup = this.$token.parent();
  }

  hideAll() {
    this.displaySides = {
      top: false,
      bottom: false,
      right: false,
      left: false
    };
  }

  setStyles() {
    const position = this.$token.position();
    this.tokenDimensions = {
      top: position.top - 1,
      left: position.left - 1,
      right: this.$token.width() + position.left + 1,
      bottom: this.$token.height() + position.top + 1
    };

    $(this.$tokenGroup.find('.grid-line-bottom')[0])
      .css('top', this.tokenDimensions.bottom);
    $(this.$tokenGroup.find('.grid-line-top')[0])
      .css('top', this.tokenDimensions.top);
    $(this.$tokenGroup.find('.grid-line-left')[0])
      .css('left', this.tokenDimensions.left);
    $(this.$tokenGroup.find('.grid-line-right')[0])
      .css('left', this.tokenDimensions.right);

    this.initialized = true;
  }

  updateDisplayFlags() {

    if (this.hide || !this.token || !this.initialized || !this.selectorDimensions) {
      this.hideAll();
      return false;
    }

    this.displaySides.top = 
      Math.abs(this.tokenDimensions.top - this.selectorDimensions.top) < closePositionPixels || 
      Math.abs(this.tokenDimensions.top - this.selectorDimensions.bottom) < closePositionPixels;
    this.displaySides.bottom =
      Math.abs(this.tokenDimensions.bottom - this.selectorDimensions.bottom) < closePositionPixels ||
      Math.abs(this.tokenDimensions.bottom - this.selectorDimensions.top) < closePositionPixels;
    this.displaySides.left = 
      Math.abs(this.tokenDimensions.left - this.selectorDimensions.left) < closePositionPixels ||
      Math.abs(this.tokenDimensions.left - this.selectorDimensions.right) < closePositionPixels;
    this.displaySides.right =
      Math.abs(this.tokenDimensions.right - this.selectorDimensions.right) < closePositionPixels ||
      Math.abs(this.tokenDimensions.right - this.selectorDimensions.left) < closePositionPixels;
  }
}

export default {
  bindings: {
    token: "=",
    snap: "<",
    hide: "<",
    selectorDimensions: "="
  },
  templateUrl: "form-builder/grid-lines/grid-lines.component.html",
  controller: GridLinesCtrl
};
